import AuthApiManager from 'services/API/AuthApi/AuthApiManager';
import LocalStorage, {LocalStorageType} from 'services/LocalStorage';
import {UserStore} from 'stores/UserStore';

export class AuthStoreBase {
  protected accessToken: string | null | undefined = '';
  protected refreshToken: string = '';
  protected authApiManager = new AuthApiManager();
  protected userStore: UserStore;

  constructor(userStore: UserStore) {
    this.userStore = userStore;

    (async () => {
      const accessToken = await LocalStorage.getValue(
        LocalStorageType.accessToken,
      );

      if (accessToken !== null) {
        this.accessToken = accessToken;
      }
    })();
  }

  signIn = async (): Promise<void> => {
    return new Promise(() => {});
  };

  signOut = async () => {
    await this.authApiManager.signOut(this.accessToken as string);
    this.userStore.logOut();
  };

  protected saveTokens = async (accessToken: string, refreshToken: string) => {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    await LocalStorage.save(accessToken, LocalStorageType.accessToken);
    await LocalStorage.save(refreshToken, LocalStorageType.refreshToken);
  };
}
